<div *ngIf="arStatusList" class="row" [ngClass]="{'mb-4': arStatusList.length != 0 }">
  <div class="col-md-12" align="center">
    <div
      *ngFor="let status of arStatusList"
      [ngClass]="{ 'active': status.id == strStatusSelected.id, 'complete': status.position < strStatusSelected.position, 'non-editable': !bEditable }"
      [ngStyle]="{'width': arStatusCustomCSS.width, 'background-color': status.position <= strStatusSelected.position ? status.color : '',
                  'cursor': status.is_allowed ? 'pointer' : 'not-allowed' }"
      (click)="updateStatus(status)"
      (myEvent)="updateStatus(status)"
      class="progress-nav btn align-middle"
      [matTooltip]="getTooltip(status)"
      (mouseover)="mouseover(status)"
      [id]="'viewProgressButton_' + status.id">
      <span>{{ status.label | translate }}</span>
      <div class="dropdown-content" *ngIf="bShowSubstatus">
        <ng-container *ngIf="jobSubStatus$ | async as jobSubStatus">
          <ng-container *ngFor="let substatus of jobSubStatus; let sub_index = index;">
          <a id="substatus_{{ substatus }}"
            (mouseover)="hoveredSubstatus = substatus.key"
            (mouseout)="hoveredSubstatus = null"
            [matTooltip]="getTooltip(substatus)"
            [ngStyle]="getSubstatusStyle(status, substatus)"
            (click)="updateSubstatus(substatus, status)"
            class="substatus-text">
              {{ substatus.text | translate }}
            </a>
          <hr
            *ngIf="sub_index != (jobSubStatus.length - 1)"
            class="separator"
          />
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>